export const deepFreeze = <T>(obj: T, depth: number = Infinity): T => {
  if (
    obj === null ||
    typeof obj !== 'object' ||
    Object.isFrozen(obj) ||
    depth <= 0
  ) {
    return obj;
  }
  Object.freeze(obj);
  // Prevent entering the loop when depth is 1, looping is the costliest part.
  if (depth === 1) {
    return obj;
  }
  for (const value of Object.values(obj)) {
    // Seems a bit superfluous to check reentrance again here, but it is a bit
    // cheaper to recurse only for none primitive values.
    if (
      value !== null &&
      typeof value === 'object' &&
      !Object.isFrozen(value)
    ) {
      deepFreeze(value, depth - 1);
    }
  }
  return obj;
};
